import { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import styled from 'styled-components';

import SVG from '../assets/svg';

const Copytoclipboard = ({
  copyText = '',
  children,
}: {
  copyText: string;
  children?: React.ReactNode;
}) => {
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleCopy = () => {
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <CopyToClipboard text={copyText} onCopy={handleCopy}>
      <Wrapper>
        <TooltipContainer
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Button
            src={isCopied ? SVG.check : SVG.copyBtn}
            alt={isCopied ? 'Copied' : 'Copy'}
          />
          {children && <div>{children}</div>}
          {isHovered && (
            <TooltipWrapper>
              <Tooltip>{isCopied ? 'Copied!' : 'copy link to the nda'}</Tooltip>
              <TooltipArrow />
            </TooltipWrapper>
          )}
        </TooltipContainer>
      </Wrapper>
    </CopyToClipboard>
  );
};

export default Copytoclipboard;

const Wrapper = styled.div`
  display: inline-flex;
  position: relative;
`;

const TooltipContainer = styled.div`
  position: relative;
  display: inline-flex;
`;

const Button = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 5px;
  cursor: pointer;
`;

const TooltipWrapper = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  z-index: 1000;
`;

const Tooltip = styled.div`
  background-color: #333;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
`;

const TooltipArrow = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #333;
`;
